import cloneDeep from 'lodash/cloneDeep'
import state from '@/store/modules/mobile-offers/state.js'
import actions from '@/store/modules/mobile-offers/actions.js'
import mutations from '@/store/modules/mobile-offers/mutations.js'
import getters from '@/store/modules/mobile-offers/getters.js'

export default {
  state: cloneDeep(state),
  actions,
  mutations,
  getters,
}
